import { ValidationConstants } from 'helpers/constants';

export const DEFAULT_MIN_PASSWORD_LENGTH_MESSAGE = `Password must be at least ${ValidationConstants.MIN_PASSWORD_LENGTH} characters long.`;
export const DEFAULT_PASSWORD_REQUIRED_MESSAGE = 'Password is required.';
export const DEFAULT_PASSWORDS_DONT_MATCH_MESSAGE = 'Passwords must match.';
export const DEFAULT_REPEAT_PASSWORD_REQUIRED_MESSAGE = 'Passwords must match.';
